<template>
  <div
    :class="classContainer"
    id="aside-left"
    data-off-canvas
    data-position="left"
  >
    <AnalyticsMenu v-if="isPath('analytics')" />
    <MessagesMenu v-if="isPath('messages')" />
    <ResourcesMenu v-if="isPath('resources')" />
    <ChallengesMenu
      v-if="isPath('challenges') || isPath('favoriteChallenges')"
    />
    <Booksmenu
      v-if="
        isPath('books') || isPath('favoriteBooks') || isPath('assignedBooks')
      "
    />
  </div>
</template>

<script>
import AnalyticsMenu from "@/components/Sidemenu/AnalyticsMenu";
import MessagesMenu from "@/components/Sidemenu/MessagesMenu";
import ResourcesMenu from "@/components/Sidemenu/ResourcesMenu";
import ChallengesMenu from "@/components/Sidemenu/ChallengesMenu";
import Booksmenu from "@/components/Sidemenu/BooksMenu";

export default {
  name: "Sidemenu",
  components: {
    AnalyticsMenu,
    MessagesMenu,
    ResourcesMenu,
    ChallengesMenu,
    Booksmenu,
  },
  data() {
    return {
      ad: true,
      classContainer: "",
      route: this.$router.history,
    };
  },
  mounted() {
    this.classContainer = this.ad
      ? "off-canvas position-left reveal-for-large kal-aside-menu demotion-1 padding-ad"
      : "off-canvas position-left reveal-for-large kal-aside-menu demotion-1";
  },
  methods: {
    isPath(dir) {
      return this.route.current.path.indexOf(`/${dir}`) >= 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@media print, screen and (min-width: 64em) {
  .off-canvas {
    margin-left: 10% !important;
  }
}
.padding-ad {
  padding-top: 50px;
}
</style>
